module.exports = __webpack_public_path__ + "static/media/elements-of-ei.30979c15.png";